module.exports = __webpack_public_path__ + "files/17e7e980c29c007c8cafc36bd418fec9.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-italic-webfont.eot
 ** module id = 435
 ** module chunks = 0
 **/